import { FeApi } from '../../..';
import {
  type SiteSoh,
  SiteSohSchema,
} from '../../../domain/entities/capacity-evaluation';

export function assetSohDataMapper(data: FeApi.SiteSohViewOutput): SiteSoh {
  const result = SiteSohSchema.safeParse({
    year: data.year,
    month: data.month,
    avgSohC: data.avg_soh_c / 100,
  });

  if (result.success) {
    return result.data;
  } else {
    console.error('Failed to parse SiteSoh:', result.error);

    const validFields = Object.fromEntries(
      Object.entries(result.error.flatten().fieldErrors).map(([key, value]) => [
        key,
        value?.[0] ?? undefined,
      ]),
    );

    return SiteSohSchema.parse({
      sohc: validFields.sohc ?? 0,
      year: validFields.year ?? 0,
      month: validFields.month ?? 0,
      avgSohC: validFields.avg_soh_c ?? 0,
    });
  }
}
